import api, { getRequest } from './client';
import { Task, TaskStatus } from "winslow-core";
import config from "environment";

const { baseApi } = config;

export const apiGetTasksForOwner = async (ownerId: string): Promise<Task[] | null> => {
  const fetchURL = `${baseApi}/tasks/owner/${ownerId}`;
  return await getRequest(fetchURL, "API/apiGetTasksForOwner");
};

export const apiGetTasksForOwnerInWorkspace = async (ownerId: string, workspaceId: string): Promise<Task[] | null> => {
  const fetchURL = `${baseApi}/tasks/owner/${ownerId}/workspace/${workspaceId}`;
  return await getRequest(fetchURL, "API/apiGetTasksForOwnerInWorkspace");
};

export const apiGetTasksByStatus = async (status: TaskStatus): Promise<Task[] | null> => {
  const fetchURL = `${baseApi}/tasks/status/${status}`;
  return await getRequest(fetchURL, "API/apiGetTasksByStatus");
};

export const apiGetTasksForOwnerAndStatus = async (ownerId: string, status: TaskStatus): Promise<Task[] | null> => {
  const fetchURL = `${baseApi}/tasks/owner/${ownerId}?status=${status}`;
  return await getRequest(fetchURL, "API/apiGetTasksForOwnerAndStatus");
};

export const apiGetActiveTasksForOwnerInWorkspace = async (ownerId: string, workspaceId: string): Promise<Task[] | null> => {
  const fetchURL = `${baseApi}/tasks/owner/${ownerId}/workspace/${workspaceId}/active`;
  return await getRequest(fetchURL, "API/apiGetActiveTasksForOwnerInWorkspace");
};

export const apiApproveTask = async (taskId: string): Promise<Task | null> => {
  const fetchURL = `${baseApi}/tasks/approve/${taskId}`;
  return await getRequest(fetchURL, "API/apiApproveTask");
};

export const apiRejectTask = async (taskId: string): Promise<Task | null> => {
  const fetchURL = `${baseApi}/tasks/reject/${taskId}`;
  return await getRequest(fetchURL, "API/apiRejectTask");
};

export const apiGetTasksForWorkflow = async (workflowId: string): Promise<Task[] | null> => {
  const fetchURL = `${baseApi}/tasks/workflow/${workflowId}`;
  return await getRequest(fetchURL, "API/apiGetTasksForWorkflow");
 }
